import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,MatSortModule } from '@angular/material';
import { Datatable } from '../../models/datatable.model';
import { AppService } from '../../services/app.service';
import { SharedService } from '../../services/shared';
import { UserService } from "../../services/user.service";
import { Router } from '@angular/router';


@Component({
    selector: 'app-datatable',
    templateUrl: './datatable.component.html',
    styleUrls: ['./datatable.component.scss']
})
export class DataTableComponent implements OnInit {
@Input() parent: any;
@Output() add = new EventEmitter();
@Output() edit = new EventEmitter();
@Output() delete = new EventEmitter();
@Output() view = new EventEmitter();
@Output() customeClick = new EventEmitter();
@Output() getPageWiseData = new EventEmitter();
@Output() getFilteredData = new EventEmitter();
@Output() getSortedData = new EventEmitter();

@Output() indicator = new EventEmitter();

resultsLength = 0;
isRateLimitReached = false;
displayedColumns = [];
indicators = "";
public parentData;
translations : any = [];
dataSource = new MatTableDataSource();
@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;
length:number = 0;
isApiUserDetails = false;

constructor(private datatableProp: Datatable, public appService: AppService,private sharedService: SharedService, public userService: UserService, private router: Router) {
    this.isApiUserDetails = this.router.url.indexOf('apiuserdetails') > -1 ? true : false;
    this.appService.checkSession();
    this.sharedService.Data.subscribe( value => {
        this.dataSource = new MatTableDataSource(value);
    });
}

ngOnInit() {
    this.setTableData();
}

back(){
    this.router.navigateByUrl('/distributor');
}

setUserParams(){
    this.userService.selectParams().subscribe((res) => {
      this.paginator.pageSize = JSON.parse(res.Data)[0].GridRecordsPerPage; 
    }); 
}

setTableData(){
    debugger;
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
    this.appService.showLoading();

    this.displayedColumns = this.datatableProp.displayedColumns;
    let colIndex = 0;
    if( this.router.url.indexOf('order') > -1){
        if (this.datatableProp.isViewDetail) {
            var view = this.datatableProp.displayedColumns.filter(d => d == 'View');
            if(view.length == 0){
                this.datatableProp.displayedColumns.splice(colIndex, 0, 'View');
                colIndex++;
            }
        }    
    }
    

    if (this.datatableProp.isEdit) {
        var edit = this.datatableProp.displayedColumns.filter(d => d == 'Edit');
        if(edit.length == 0){
            this.datatableProp.displayedColumns.splice(colIndex, 0, 'Edit');
            colIndex++;
        }
    }

    if (this.datatableProp.isDelete) {
        var deleteRes = this.datatableProp.displayedColumns.filter(e => e == 'Delete');
        if(deleteRes.length == 0){
            this.datatableProp.displayedColumns.splice(colIndex, 0, 'Delete');
            colIndex++;
        }
    }
    if (this.datatableProp.iscustom) {
        for (let i = 0; i < this.datatableProp.gridControl.length; i++) {
            var customRes = this.datatableProp.displayedColumns.filter(e => e == this.datatableProp.gridControl[i].Name);
            if(customRes.length == 0){                                                            
                this.datatableProp.displayedColumns.splice(colIndex, 0, this.datatableProp.gridControl[i].Name);
                colIndex++;
            }
        }
    }
    this.dataSource = new MatTableDataSource(this.parent.data);
    this.parentData = this.parent.data;
    this.appService.hideLoading();
}
addRecord() {
    this.appService.showLoading();
    this.add.emit();
}

editRecord(e) {
    debugger;
    this.appService.showLoading();
    this.edit.emit(e);
}
viewRecord(e){
    debugger;
    this.appService.showLoading();
    this.view.emit(e);
}

deleteRecord(e) {
    this.delete.emit(e);
}
customRecord(e, type: Number) {
    this.customeClick.emit(e);
}

indicatorClicked(e){
    var orderId = e.currentTarget.id;
    var remarkBy = e.currentTarget.getAttribute("column") == 'D_Remark' ? "distributor" : 'shipper';
    var invoiceNo = e.currentTarget.getAttribute('data-invno');
    var cName = e.currentTarget.getAttribute('data-cname');
    var eventParams = { OrderId: orderId, RemarkBy: remarkBy, InvoiceNo: invoiceNo, C_Name: cName };
    this.indicator.emit(eventParams);
}

ngAfterViewInit() {
    this.userService.selectParams().subscribe((res) => {
        this.dataSource.paginator = this.paginator;
        let recordsPerPage: any = res.Status == -1 ? 10 : JSON.parse(res.Data)[0].GridRecordsPerPage;
        let pageSize: number = +(parseInt(recordsPerPage));
        this.paginator.pageSize = pageSize;
        this.dataSource.paginator.pageSize = pageSize;
        this.dataSource.sort = this.sort;
        this._updatePaginator(this.parent.length, pageSize, this.parent.pageIndex);
    }); 
}

applyFilter(e) {
    this.parent.filterText = e.trim(); // Remove whitespace
    this.parent.filterText = this.parent.filterText.toLowerCase(); // Datasource defaults to lowercase matches
    //this.dataSource.filter = filterValue;
    this.getFilteredData.emit(this.parent.filterText);
}

isCustomColumn(columnName) {
    if (this.datatableProp.iscustom){
        return (this.datatableProp.displayedColumns.indexOf(columnName) > -1 && this.datatableProp.gridControl.some(function (o) { return o["Name"] === columnName; }));
    }
    else{
        return false;
    } 
}

getCustomControProp(name,prop){
    
    for (let i = 0; i < this.datatableProp.gridControl.length; i++) {
        if(this.datatableProp.gridControl[i].Name == name){
            if(prop != 'ToolTip')
                return this.datatableProp.gridControl[i][prop];
            else
                return this.translations[this.datatableProp.gridControl[i][prop]];
        }
    }
}

getToolTip(key){
    
    let tooltip = JSON.parse(sessionStorage.pageData)[key];
    return typeof tooltip != 'undefined' ? tooltip :'';
}

getServerData(event){
    this.userService.saveParams(event.pageSize).subscribe((res) => {
        this.getPageWiseData.emit(event); 
    });
}

_updatePaginator(filteredDataLength: number, pageSize: number, pageIndex: number) { 
    Promise.resolve().then(() => { 
        if (!this.paginator) { 
            return; 
        } 
        this.paginator.length = filteredDataLength; 
        if (pageIndex > 0) { 
            const lastPageIndex = Math.ceil(this.paginator.length / pageSize) - 1 || 0; 
            this.paginator.pageIndex = Math.min(pageIndex, lastPageIndex); 
        } 
    }); 
} 

sortData(event, i){
    this.parent.sortDirection = event.direction;
    this.parent.sortHeaderName = event.active;
}
getColumnDetails(event){
    this.getSortedData.emit(event);
}

getColumnColor(columnName, ColumnValue, row){
    if(columnName == 'Order Type'){
        if(row['TypeId'] === 162){
            return '#4caf50';
        }
        else if(row['TypeId'] === 163){
            return '#f44336';
        }
        else{
            return '';
        }
    }


    if(columnName == 'Paid To'){
        if(row['P_PaidTo'] === 201){
            return 'blue';
        }
        else if(row['P_PaidTo'] === 202){
            return 'orange';
        }
        else{
            return 'red';
        }
    }

    if(columnName == 'D_Remark'){
        if(row['S_IsRead'] === 0){          //no remark
            return 'grey';
        }
        else if(row['S_IsRead'] === 1){     //unread
            return 'blue'; 
        }
        else if(row['S_IsRead'] === 2){     //read
            return 'grey';
         }else{
              return 'grey';
         }
    }

    if(columnName == 'S_Remark'){
        if(row['D_IsRead'] === 0){          //no remark
            return 'grey';
        }
        else if(row['D_IsRead'] === 1){     //unread
            return 'blue';
        }
        else if(row['D_IsRead'] === 2){     //read
            return 'grey';
         }else{
             return 'grey';
        }
    }
    
    if(columnName == 'Status'){
        if(row['StatusId'] === 151){
            return '#0d47a1';
        }
        else if(row['StatusId'] === 152){
            return '#000000';
        }
        else if(row['StatusId'] === 153){
            return 'rgba(255, 166, 0, 0.945)';
        }
        else if(row['StatusId'] === 154){
            return '#f44336';
        }
        else if(row['StatusId'] === 155){
            return '#4CAF50';
        }
        else if(row['StatusId'] === 156){
            return '#00FFFF';
        }
        else{
            return '';
        }
    }
    return '';
}

getIndicatorIcon(columnName, ColumnValue, row){
    if(columnName == 'D_Remark'){
        if(row['S_IsRead'] === 0){          //no remark
            return "panorama_fish_eye";
        }
        else if(row['S_IsRead'] === 1){     //unread
            return "check_circle_outline"; 
        }
        else if(row['S_IsRead'] === 2){     //read
            return "check_circle_outline";
         }else{
              return "panorama_fish_eye";
         }
    }

    if(columnName == 'S_Remark'){
        if(row['D_IsRead'] === 0){          //no remark
            return "panorama_fish_eye";
        }
        else if(row['D_IsRead'] === 1){     //unread
            return "check_circle_outline"; 
        }
        else if(row['D_IsRead'] === 2){     //read
            return "check_circle_outline"; 
         }else{
             return "panorama_fish_eye";
        }
    }
}

getColumnTranslation(column){   
    let translatedData = '';
    if(this.translations){
        for(let i = 0; i< this.datatableProp.columnKeyData.length; i++){
            if(this.datatableProp.columnKeyData[i].ColumnName == column && typeof this.translations[this.datatableProp.columnKeyData[i]['ColumnIdentity']] != 'undefined'){
                translatedData = this.translations[this.datatableProp.columnKeyData[i]['ColumnIdentity']];
                return translatedData;           
            }
        }
    }
    return translatedData;
}

isIndicationColumn(columnName){
    if(this.datatableProp.indicators != undefined){
        return this.datatableProp.indicators.indexOf('|' + columnName + '|') > -1;
    }else
        return false;
}

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/datatable/datatable.component.ts